const name = 'module/docs-templates';

export const UPDATE_DOCS_TEMPLATE_REQUEST = `${name}/UPDATE_DOCS_TEMPLATE_REQUEST`;
export const UPDATE_DOCS_TEMPLATE_SUCCESS = `${name}/UPDATE_DOCS_TEMPLATE_SUCCESS`;
export const UPDATE_DOCS_TEMPLATE_FAILURE = `${name}/UPDATE_DOCS_TEMPLATE_FAILURE`;

export const DELETE_DOCS_TEMPLATE_REQUEST = `${name}/DELETE_DOCS_TEMPLATE_REQUEST`;
export const DELETE_DOCS_TEMPLATE_SUCCESS = `${name}/DELETE_DOCS_TEMPLATE_SUCCESS`;
export const DELETE_DOCS_TEMPLATE_FAILURE = `${name}/DELETE_DOCS_TEMPLATE_FAILURE`;

export const GET_DOCS_TEMPLATE_DETAILS_REQUEST = `${name}/GET_DOCS_TEMPLATE_DETAILS_REQUEST`;
export const GET_DOCS_TEMPLATE_DETAILS_SUCCESS = `${name}/GET_DOCS_TEMPLATE_DETAILS_SUCCESS`;
export const GET_DOCS_TEMPLATE_DETAILS_FAILURE = `${name}/GET_DOCS_TEMPLATE_DETAILS_FAILURE`;

export const CREATE_ORDER_DOCUMENT_REQUEST = `${name}/CREATE_ORDER_DOCUMENT_REQUEST`;
export const CREATE_ORDER_DOCUMENT_SUCCESS = `${name}/CREATE_ORDER_DOCUMENT_SUCCESS`;
export const CREATE_ORDER_DOCUMENT_FAILURE = `${name}/CREATE_ORDER_DOCUMENT_FAILURE`;

export const DELETE_ORDER_DOCUMENT_REQUEST = `${name}/DELETE_ORDER_DOCUMENT_REQUEST`;
export const DELETE_ORDER_DOCUMENT_SUCCESS = `${name}/DELETE_ORDER_DOCUMENT_SUCCESS`;
export const DELETE_ORDER_DOCUMENT_FAILURE = `${name}/DELETE_ORDER_DOCUMENT_FAILURE`;

export default name;
